export default "__VITE_ASSET__DpL7lvFW__"